import { getContacts } from './getContacts'
import { getSeo } from './getSeo'

export * from './getContacts'
export * from './getSeo'

export const contactsApi = {
  getContacts,
  getSeo,
}
